module.exports = __webpack_public_path__ + "img/beethovensw_finale01.9d3a1363.png";